import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";

var PopoverBox = function PopoverBox(_ref) {
  var children = _ref.children,
      boxClass = _ref.boxClass,
      boxStyles = _ref.boxStyles;
  var getClassName = getClassNameFactory(PopoverBox.displayName);
  return /*#__PURE__*/React.createElement("div", {
    style: boxStyles,
    className: getClassName({
      modifiers: classNames(boxClass)
    })
  }, children);
};

PopoverBox.displayName = "PopoverBox";
export default PopoverBox;